import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

interface IState {
  isLoggedIn: boolean;
}

const Token = Cookies.get("Token");

const initialState: IState = { isLoggedIn: Boolean(Token) };

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      Cookies.set("Token", action.payload, { expires: 30 });
      return { isLoggedIn: true };
    },
    logout: () => {
      Cookies.remove("Token");
      return { isLoggedIn: false };
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
